import { actions } from "@grandvisionhq/state";
const tealiumRxConfiguratorViewStep = actions.action(
  "tealium/rx-configurator/view-step",
  actions.payload()
);
export {
  tealiumRxConfiguratorViewStep
};
//# sourceMappingURL=actions.js.map
